var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18.21,
  height: 18.21,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 3C15.4183 3 19 6.58172 19 11C19 12.8482 18.3733 14.55 17.3207 15.9045L21.2071 19.7929L19.7929 21.2071L15.9045 17.3207C14.55 18.3733 12.8482 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3ZM11 5C7.68629 5 5 7.68629 5 11C5 14.3137 7.68629 17 11 17C14.3137 17 17 14.3137 17 11C17 7.68629 14.3137 5 11 5Z",
  fill: "#A4A4A4"
})));
export { SvgSearch as ReactComponent };
export default __webpack_public_path__ + "assets/2ddd73a4.svg";